module.exports = __webpack_public_path__ + "img/Slovenia.cc87f450.png";